import React, { useEffect, useState } from "react";
import {
  addDays,
  addMonths,
  eachDayOfInterval,
  endOfMonth,
  format,
  getDay,
  isSameDay,
  isToday,
  startOfMonth,
  subDays,
  subMonths,
  isSameMonth
} from "date-fns";
import { useTranslation } from "react-i18next";
import LeaveTooltip from "./LeaveTooltip";
import HolidaysTooltip from "./HolidaysTooltip";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { IconButton, Popover } from "@mui/material";
import LeaveApi from "../../../axios/LeaveAndHoliday/LeaveApi";
import { toast } from "react-toastify";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useLoading } from "../../../context/LoadingContext";
import { useAuth } from "../../../context/AuthContext";
import { DateTime } from "luxon";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ClockWarning16pxSvg from "../../../assets/images/icons/ClockWarning16pxSvg";
import CloseReject16pxSvg from "../../../assets/images/icons/CloseReject16pxSvg";
import UserRemoveIcon16pxSvg from "../../../assets/images/icons/UserRemoveIcon16pxSvg";
import TickApporve16pxSvg from "../../../assets/images/icons/TickApporve16pxSvg";
import LeaveHolidayIcon20pxSvg from "../../../assets/images/icons/LeaveHolidayIcon20pxSvg";
import ShiftRosterIcon20pxSvg from "../../../assets/images/icons/ShiftRosterIcon20pxSvg";

dayjs.extend(utc);
dayjs.extend(timezone);

const LeaveAndHolidaysMonthEventsCalendar = (props) => {
  const {
    tabValue,
    setSelectedDate,
    selectedDate,
    refreshData,
    calculateDisplayedWeeks,
    formatLeaveFilter,
    selectedUser,
  } = props;
  const { t,  } = useTranslation();
  const { calendarLeave, calendarLeaveRequest } = LeaveApi();
  const [monthCalendarItemData, setMonthCalendarItemData] = useState([]);
  const [show, hide] = useLoading();
  const { isAdmin, profile, genaralSettingTimeZone } = useAuth();
  const months = [
    t("common.january"),
    t("common.february"),
    t("common.march"),
    t("common.april"),
    t("common.may"),
    t("common.june"),
    t("common.july"),
    t("common.august"),
    t("common.september"),
    t("common.october"),
    t("common.november"),
    t("common.december"),
  ];

  const weekDays = [
    t("common.monday3"),
    t("common.tuesday3"),
    t("common.wednesday3"),
    t("common.thursday3"),
    t("common.friday3"),
    t("common.saturday3"),
    t("common.sunday3"),
  ];
  useEffect(() => {
    if (selectedDate) {
      const currentDate = new Date(selectedDate);
      calculateDisplayedWeeks(currentDate, weekDays[0]);
    }
  }, [selectedDate, weekDays]);

  useEffect(() => {
    if (!selectedDate) return;

    if (!isSameMonth(selectedDate, currentDate)) {
      setCurrentDate(startOfMonth(selectedDate));
    }
  }, [selectedDate]);

  const RecurringHolidaysIcon16pxSvg = (fill) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M11.1667 2.37331V1.33331C11.1667 1.05998 10.94 0.833313 10.6667 0.833313C10.3933 0.833313 10.1667 1.05998 10.1667 1.33331V2.33331H5.83332V1.33331C5.83332 1.05998 5.60666 0.833313 5.33332 0.833313C5.05999 0.833313 4.83332 1.05998 4.83332 1.33331V2.37331C3.03332 2.53998 2.15999 3.61331 2.02666 5.20665C2.01332 5.39998 2.17332 5.55998 2.35999 5.55998H13.64C13.8333 5.55998 13.9933 5.39331 13.9733 5.20665C13.84 3.61331 12.9667 2.53998 11.1667 2.37331Z"
          fill="#fa5a7d"
        />
        <path
          d="M13.3333 6.56H2.66667C2.3 6.56 2 6.86 2 7.22666V11.3333C2 13.3333 3 14.6667 5.33333 14.6667H10.6667C13 14.6667 14 13.3333 14 11.3333V7.22666C14 6.86 13.7 6.56 13.3333 6.56ZM6.14 12.14C6.10667 12.1667 6.07333 12.2 6.04 12.22C6 12.2467 5.96 12.2667 5.92 12.28C5.88 12.3 5.84 12.3133 5.8 12.32C5.75333 12.3267 5.71333 12.3333 5.66667 12.3333C5.58 12.3333 5.49333 12.3133 5.41333 12.28C5.32667 12.2467 5.26 12.2 5.19333 12.14C5.07333 12.0133 5 11.84 5 11.6667C5 11.4933 5.07333 11.32 5.19333 11.1933C5.26 11.1333 5.32667 11.0867 5.41333 11.0533C5.53333 11 5.66667 10.9867 5.8 11.0133C5.84 11.02 5.88 11.0333 5.92 11.0533C5.96 11.0667 6 11.0867 6.04 11.1133C6.07333 11.14 6.10667 11.1667 6.14 11.1933C6.26 11.32 6.33333 11.4933 6.33333 11.6667C6.33333 11.84 6.26 12.0133 6.14 12.14ZM6.14 9.80666C6.01333 9.92666 5.84 10 5.66667 10C5.49333 10 5.32 9.92666 5.19333 9.80666C5.07333 9.68 5 9.50666 5 9.33333C5 9.16 5.07333 8.98666 5.19333 8.86C5.38 8.67333 5.67333 8.61333 5.92 8.72C6.00667 8.75333 6.08 8.8 6.14 8.86C6.26 8.98666 6.33333 9.16 6.33333 9.33333C6.33333 9.50666 6.26 9.68 6.14 9.80666ZM8.47333 12.14C8.34667 12.26 8.17333 12.3333 8 12.3333C7.82667 12.3333 7.65333 12.26 7.52667 12.14C7.40667 12.0133 7.33333 11.84 7.33333 11.6667C7.33333 11.4933 7.40667 11.32 7.52667 11.1933C7.77333 10.9467 8.22667 10.9467 8.47333 11.1933C8.59333 11.32 8.66667 11.4933 8.66667 11.6667C8.66667 11.84 8.59333 12.0133 8.47333 12.14ZM8.47333 9.80666C8.44 9.83333 8.40667 9.86 8.37333 9.88666C8.33333 9.91333 8.29333 9.93333 8.25333 9.94666C8.21333 9.96666 8.17333 9.98 8.13333 9.98666C8.08667 9.99333 8.04667 10 8 10C7.82667 10 7.65333 9.92666 7.52667 9.80666C7.40667 9.68 7.33333 9.50666 7.33333 9.33333C7.33333 9.16 7.40667 8.98666 7.52667 8.86C7.58667 8.8 7.66 8.75333 7.74667 8.72C7.99333 8.61333 8.28667 8.67333 8.47333 8.86C8.59333 8.98666 8.66667 9.16 8.66667 9.33333C8.66667 9.50666 8.59333 9.68 8.47333 9.80666ZM10.8067 12.14C10.68 12.26 10.5067 12.3333 10.3333 12.3333C10.16 12.3333 9.98667 12.26 9.86 12.14C9.74 12.0133 9.66667 11.84 9.66667 11.6667C9.66667 11.4933 9.74 11.32 9.86 11.1933C10.1067 10.9467 10.56 10.9467 10.8067 11.1933C10.9267 11.32 11 11.4933 11 11.6667C11 11.84 10.9267 12.0133 10.8067 12.14ZM10.8067 9.80666C10.7733 9.83333 10.74 9.86 10.7067 9.88666C10.6667 9.91333 10.6267 9.93333 10.5867 9.94666C10.5467 9.96666 10.5067 9.98 10.4667 9.98666C10.42 9.99333 10.3733 10 10.3333 10C10.16 10 9.98667 9.92666 9.86 9.80666C9.74 9.68 9.66667 9.50666 9.66667 9.33333C9.66667 9.16 9.74 8.98666 9.86 8.86C9.92667 8.8 9.99333 8.75333 10.08 8.72C10.2 8.66666 10.3333 8.65333 10.4667 8.68C10.5067 8.68666 10.5467 8.7 10.5867 8.72C10.6267 8.73333 10.6667 8.75333 10.7067 8.78C10.74 8.80666 10.7733 8.83333 10.8067 8.86C10.9267 8.98666 11 9.16 11 9.33333C11 9.50666 10.9267 9.68 10.8067 9.80666Z"
          fill="#fa5a7d"
        />
      </svg>
    );
  };
  const HolidayIcon16pxSvg = (fill) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M10.0002 12.36C11.4202 12.14 13.0002 12 14.6668 12V14.6666H3.3335C3.3335 14.2333 5.46683 13.24 8.66683 12.6V8.26665C8.10683 8.43331 7.6335 8.80665 7.3335 9.29998C7.12673 8.95403 6.83376 8.66763 6.48321 8.46876C6.13267 8.26989 5.73653 8.16535 5.3335 8.16535C4.93047 8.16535 4.53433 8.26989 4.18378 8.46876C3.83323 8.66763 3.54026 8.95403 3.3335 9.29998C3.3535 6.91331 5.66683 4.95331 8.66683 4.69331V4.66665C8.66683 4.48984 8.73707 4.32027 8.86209 4.19524C8.98712 4.07022 9.15669 3.99998 9.3335 3.99998C9.51031 3.99998 9.67988 4.07022 9.8049 4.19524C9.92992 4.32027 10.0002 4.48984 10.0002 4.66665V4.69331C13.0002 4.95331 15.3068 6.91331 15.3335 9.29998C15.1267 8.95403 14.8338 8.66763 14.4832 8.46876C14.1327 8.26989 13.7365 8.16535 13.3335 8.16535C12.9305 8.16535 12.5343 8.26989 12.1838 8.46876C11.8332 8.66763 11.5403 8.95403 11.3335 9.29998C11.0335 8.80665 10.5602 8.43331 10.0002 8.25998V12.36ZM4.66683 1.33331C4.66683 1.77105 4.58061 2.20451 4.41309 2.60892C4.24558 3.01334 4.00005 3.38081 3.69052 3.69034C3.38099 3.99986 3.01353 4.2454 2.60911 4.41291C2.20469 4.58043 1.77124 4.66665 1.3335 4.66665V1.33331H4.66683Z"
          fill="#3cd856"
        />
      </svg>
    );
  };

  const [currentDate, setCurrentDate] = useState(new Date());
  const currentMonthByText = months[currentDate.getMonth()];
  const currentYear = currentDate.getFullYear();
  const getEventsForDay = (day) => {
    const formattedDay = format(day, "yyyy-MM-dd");
    return monthCalendarItemData.filter((event) => event.date === formattedDay);
  };

  const firstDayOfMonth = startOfMonth(currentDate);
  const lastDayOfMonth = endOfMonth(currentDate);
  const daysInMonth = eachDayOfInterval({
    start: firstDayOfMonth,
    end: lastDayOfMonth,
  });

  const handlePrevMonth = () => {
    setCurrentDate(prev =>
      new Date(prev.getFullYear(), prev.getMonth() - 1, 1)
    );
    setSelectedDate(subMonths(selectedDate, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(prev =>
      new Date(prev.getFullYear(), prev.getMonth() + 1, 1)
    );
    setSelectedDate(addMonths(selectedDate, 1));
  };

  // const startingDateIndex = getDay(firstDayOfMonth) - 1
  const startingDateIndex =
    getDay(firstDayOfMonth) === 0 ? 6 : getDay(firstDayOfMonth) - 1;

  const getNextMonthDays = (lastDayOfMonth, emptyCell) => {
    const nextMonthDays = [];
    for (let i = 1; i <= emptyCell; i++) {
      nextMonthDays.push(addDays(lastDayOfMonth, i));
    }
    return nextMonthDays;
  };

  const getPrevMonthDays = (firstDayOfMonth, emptyCell) => {
    const prevMonthDays = [];
    for (let i = 1; i <= emptyCell; i++) {
      prevMonthDays.unshift(subDays(firstDayOfMonth, i));
    }
    return prevMonthDays;
  };

  const totalDays = daysInMonth.length + startingDateIndex;
  const totalCells = totalDays > 35 ? 42 : 35;
  // const totalCells = 7 * 6;
  const emptyCellsForNextMonth =
    totalCells - (daysInMonth.length + startingDateIndex);
  const nextMonthDays = getNextMonthDays(
    lastDayOfMonth,
    emptyCellsForNextMonth
  );
  const prevMonthDays = getPrevMonthDays(firstDayOfMonth, startingDateIndex);

  const legendData = React.useMemo(() => {
    if (tabValue === 2) {
      return [
        { color: <div className="rounded-full w-3 h-3 bg-[#0057FF]" />, display: t("common.current-day") },
        { color: <div className="rounded-full w-3 h-3 bg-[#853EEF]" />, display: t("common.holidays") },
        { color: <div className="rounded-full w-3 h-3 bg-[#058900]" />, display: t("common.recurring-holidays") },
        { color: <div className="rounded-full w-3 h-3 bg-[#0EA5E9]" />, display: t("common.selected-day") },
      ];
    }

    if (tabValue === 1) {
      return [
        { color: <div className="rounded-full w-3 h-3 bg-[#0057FF]" />, display: t("common.current-day") },
        { color: <div className="rounded-full w-3 h-3 bg-[#0EA5E9]" />, display: t("common.selected-day") },
        { color: <div className="rounded-full w-3 h-3 bg-[#058900]" />, display: t("common.approved") },
        { color: <div className="rounded-full w-3 h-3 bg-[#D00D00]" />, display: t("common.rejected") },
        { color: <div className="rounded-full w-3 h-3 bg-[#F97C00]" />, display: t("common.pending") },
      ];
    }

    return [
      {
        color: <div className="rounded-full w-3 h-3 bg-[#0057FF]" />,
        display: t("common.current-day"),
      },
      {
        color: <div className="rounded-full w-3 h-3 bg-[#0EA5E9]" />,
        display: t("common.selected-day"),
      },
      {
        color: <div className="rounded-full w-3 h-3 bg-[#FF0066]" />,
        display: t("common.leaves"),
      },
    ];
  }, [tabValue, t]);

  const lastRequestId = React.useRef(0);

  const getMonthRangeByTZ = (date, timeZone) => {
    const zone = timeZone || "+00:00";
    const base = DateTime.fromJSDate(date, { zone });

    return {
      from: base.startOf("month").toUTC().toISO(),
      to: base.endOf("month").toUTC().toISO(),
    };
  };

  const getMonthRangeUTC = (date) => {
    const start = new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      1,
      0, 0, 0
    ));

    const end = new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth() + 1,
      0,
      23, 59, 59
    ));

    return {
      from: start.toISOString(),
      to: end.toISOString(),
    };
  };

  const fetchCalendarEventList = async (currentMonth, currentYear, reqId) => {
    try {
      // setLoading(true)
      const browserTZ = dayjs.tz.guess();
      const { from, to } = getMonthRangeByTZ(selectedDate, genaralSettingTimeZone);
      show();
      const payload = {
        from,
        to,
        langId: localStorage.getItem("i18nextLngId"),
        userId: isAdmin ? selectedUser?.id : profile.userId,
        groupId:
          formatLeaveFilter.group !== 1 ? formatLeaveFilter.group : null,
      };

      const isRequestMode = tabValue === 1;
      if (isRequestMode) {
        const requestStatusMap = {
          1: "APPROVED",
          2: "REJECTED",
          3: "PENDING",
        };
        const statusFilter =
          formatLeaveFilter.selecStatusLeave !== 0
            ? requestStatusMap[formatLeaveFilter.selecStatusLeave]
            : null;

        if (statusFilter) {
          payload.requestStatus = statusFilter;
        }
      }

      const response = isRequestMode
        ? await calendarLeaveRequest(payload)
        : await calendarLeave(payload);
      if (
        response.data.message === "Successful" ||
        response.data.message === "Thành công"
      ) {
        // setLoading(false)
        if (lastRequestId.current === reqId) {
          setMonthCalendarItemData(response.data.data);
        }
      }
    } catch (error) {
      console.error("Leave calendar fetch error:", error);
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data.message));
        }
      } else if (error?.message?.includes("Invalid time zone")) {
        toast.error(error.message);
      } else {
        toast.error(t('common.network-timeout'));
      }
    } finally {
      // setLoading(false);
      hide();
    }
  };


  useEffect(() => {
    setMonthCalendarItemData([]);
    const currentMonth = currentDate.getMonth() + 1;
    const currentYear = currentDate.getFullYear();
    const reqId = ++lastRequestId.current;
    fetchCalendarEventList(currentMonth, currentYear, reqId);
  }, [
    refreshData,
    currentDate,
    selectedDate,
    isAdmin,
    profile?.userId,
    tabValue,
    formatLeaveFilter.group,
    formatLeaveFilter.selecStatusLeave,
    selectedUser,
    genaralSettingTimeZone,
  ]);

  const handleSelectDay = (day) => {
    setSelectedDate(day);
  };

  const handleMonthYearChange = (newDate) => {
    setCurrentDate(newDate);
    setSelectedDate(newDate);
  };

  const MonthYearPicker = ({ selectedDate, onChange }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [year, setYear] = useState(selectedDate.getFullYear());

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const open = Boolean(anchorEl);

    const handleSelect = (monthIndex) => {
      const newDate = new Date(year, monthIndex, selectedDate.getDate());
      onChange(newDate);
      handleClose();
    };

    return (
      <>
        <button
          onClick={handleOpen}
          className="flex items-center gap-1 border px-3 py-1 rounded shadow-sm bg-white hover:bg-gray-100 h-10"
        >
          <span className="relative text-[#49494B]" style={{ top: "0.05rem" }}>
            {months[selectedDate.getMonth()]} {selectedDate.getFullYear()}
          </span>
          <ArrowDropDownIcon fontSize="small" className="text-[#49494B]" />
        </button>

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <div className="p-4 w-64 sm:w-80">
            <div className="flex justify-between items-center mb-3 text-[#757575]">
              <button onClick={() => setYear(year - 1)}>
                <ArrowBackIosNewIcon
                  fontSize="small"
                  className="text-[#757575]"
                />
              </button>
              <span className="font-medium">{year}</span>
              <button onClick={() => setYear(year + 1)}>
                <ArrowForwardIosIcon
                  fontSize="small"
                  className="text-[#757575]"
                />
              </button>
            </div>

            <div className="grid grid-cols-3 gap-2 text-[#757575]">
              {months.map((month, index) => (
                <button
                  key={index}
                  className={`py-1 rounded w-full ${selectedDate.getMonth() === index &&
                    selectedDate.getFullYear() === year
                    ? "bg-blue-600 text-white"
                    : "hover:bg-gray-200"
                    }`}
                  onClick={() => handleSelect(index)}
                >
                  {month}
                </button>
              ))}
            </div>
          </div>
        </Popover>
      </>
    );
  };

  const getRequestDayData = (eventsForDay) => {
    return eventsForDay.reduce(
      (acc, event) => ({
        approved:
          acc.approved +
          (event.sumRequestApproved || event.sumApproveLeave || event.numOfUser || 0),
        pending: acc.pending + (event.sumRequestPending || 0),
        rejected: acc.rejected + (event.sumRejectLeave || 0),
      }),
      { approved: 0, pending: 0, rejected: 0 }
    );
  };

  const renderEmptyDayCell = () => (
    <div className="border border-[#E5E7EB] bg-[#FFFFFF] rounded-md h-[22px] w-full flex items-center justify-center mt-1">
      <p className="text-[10px] text-[#E5E7EB] leading-none">{t("common.content-122")}</p>
    </div>
  );

  const renderLeaveDayCell = (leaveCount) => (
    <LeaveTooltip noLeaves={false} personLeave={leaveCount}>
      <div className="border border-[#E5E7EB] bg-[#FFFFFF] rounded-md min-h-[22px] h-[22px] w-full flex items-center justify-center mt-1 px-1 gap-1">
        <UserRemoveIcon16pxSvg />
        <p className="text-[10px] text-[#FF0066] font-semibold leading-none">{leaveCount}</p>
      </div>
    </LeaveTooltip>
  );

  const renderRequestStatusCell = (dayData) => {
    return (
      <div className="border border-[#E5E7EB] bg-[#FFFFFF] rounded-md min-h-[22px] h-[22px] w-full flex items-center justify-center mt-1 px-1 gap-1.5">
        {dayData.approved > 0 && (
          <p className="flex items-center gap-0.5 text-[10px] text-[#058900] font-semibold leading-none">
            <TickApporve16pxSvg /> {dayData.approved}
          </p>
        )}
        {dayData.pending > 0 && (
          <p className="flex items-center gap-0.5 text-[10px] text-[#F97C00] font-semibold leading-none">
            <ClockWarning16pxSvg /> {dayData.pending}
          </p>
        )}
        {dayData.rejected > 0 && (
          <p className="flex items-center gap-0.5 text-[10px] text-[#D00D00] font-semibold leading-none">
            <CloseReject16pxSvg /> {dayData.rejected}
          </p>
        )}
      </div>
    );
  };

  return (
    <div className="month-calendar rounded-[10px] px-3 sm:px-3 md:px-3 py-3">
      <div className="relative h-10 flex items-center">
        <IconButton
          size="small"
          onClick={handlePrevMonth}
          className="!absolute left-0"
        >
          <ChevronLeftIcon />
        </IconButton>

        <div className="w-full text-center px-8 sm:px-10">
          <p className="text-base sm:text-lg md:text-xl text-[#1F2937] font-semibold">
            {currentMonthByText}, {currentYear}
          </p>
        </div>

        <IconButton
          size="small"
          onClick={handleNextMonth}
          className="!absolute right-0"
        >
          <ChevronRightIcon />
        </IconButton>
      </div>
      <div className="mt-4">
        <div className="grid grid-cols-7 text-center">
          {weekDays.map((day) => (
            <div key={day}>
              <p className="uppercase font-semibold text-[10px] sm:text-xs text-[#49494B]">
                {day}
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-7 text-center border-t border-l border-[#DBE8FF]">
          {prevMonthDays.map((day, index) => {
            const isSelectedDay = selectedDate && isSameDay(day, selectedDate);
            const isCurrentDay = isToday(day);

            return (
              <div
                className="day prev-month border-r border-b border-[#DBE8FF]"
                style={
                  isSelectedDay
                    ? { backgroundColor: "#F5F8FF", border: "1px solid #0EA5E9" }
                    : isCurrentDay
                    ? {
                        backgroundColor: "#F5F8FF",
                       
                      }
                    : undefined
                }
                key={-index - 1}
                onClick={() => handleSelectDay(day)}
              >
                <div className="text-xs">{format(day, "d")}</div>
              </div>
            );
          })}
          {daysInMonth.map((day, index) => {
            const eventsForDay = getEventsForDay(day);
            const isSelectedDay = selectedDate && isSameDay(day, selectedDate);
            const isCurrentDay = isToday(day);
            const requestDayData = getRequestDayData(eventsForDay);
            const leaveCount = eventsForDay.reduce(
              (sum, event) => sum + (event.numOfUser || 0),
              0
            );
            const hasRequestData =
              requestDayData.approved > 0 ||
              requestDayData.pending > 0 ||
              requestDayData.rejected > 0;
            const hasHolidayData = eventsForDay.some(
              (event) => event.description !== null
            );

            return (
              <div
                className="day border-r border-b border-[#DBE8FF] hover:bg-gray-100 cursor-pointer transition"
                style={
                  isSelectedDay
                    ? { backgroundColor: "#F5F8FF", border: "1px solid #0EA5E9" }
                    : isCurrentDay
                    ? {
                        backgroundColor: "#F5F8FF",
                      
                      }
                    : undefined
                }
                key={index}
                onClick={() => handleSelectDay(day)}
              >
                <div className="text-xs font-medium">{format(day, "d")}</div>

                {tabValue === 0 && (
                  leaveCount > 0 ? (
                    renderLeaveDayCell(leaveCount)
                  ) : (
                    <LeaveTooltip noLeaves={true}>{renderEmptyDayCell()}</LeaveTooltip>
                  )
                )}

                {tabValue === 1 && (
                  hasRequestData ? (
                    renderRequestStatusCell(requestDayData)
                  ) : (
                    <LeaveTooltip noLeaves={true}>{renderEmptyDayCell()}</LeaveTooltip>
                  )
                )}

                {tabValue === 2 && (
                  hasHolidayData ? (
                    eventsForDay.map(
                      (event, eventIndex) =>
                        event.description !== null && (
                          <HolidaysTooltip
                            key={eventIndex}
                            description={event.description}
                            noHoliday={event.description === null}
                          >
                            <div
                              className="rounded-md min-h-[22px] h-[22px] w-full flex items-center justify-center mt-1 px-1 gap-1 border"
                              style={
                                event.isHolidayRecurring === true
                                  ? {
                                      backgroundColor: "#F0FDF4",
                                      borderColor: "#058900",
                                    }
                                  : event.isHolidayNormal === true
                                  ? {
                                      backgroundColor: "#F3ECFD",
                                      borderColor: "#853EEF",
                                    }
                                  : {
                                      backgroundColor: "transparent",
                                      borderColor: "#93C5FD",
                                    }
                              }
                            >
                              {event.isHolidayRecurring === true && (
                                <ShiftRosterIcon20pxSvg color="#058900" />
                              )}
                              {event.isHolidayNormal === true && (
                                <LeaveHolidayIcon20pxSvg color="#853EEF" />
                              )}
                            </div>
                          </HolidaysTooltip>
                        )
                    )
                  ) : (
                    <LeaveTooltip noLeaves={true}>{renderEmptyDayCell()}</LeaveTooltip>
                  )
                )}
              </div>
            );
          })}
          {nextMonthDays.map((day, index) => {
            const isSelectedDay = selectedDate && isSameDay(day, selectedDate);
            const isCurrentDay = isToday(day);

            return (
              <div
                className="day next-month border-r border-b border-[#DBE8FF]"
                style={
                  isSelectedDay
                    ? { backgroundColor: "#F5F8FF", border: "1px solid #0EA5E9" }
                    : isCurrentDay
                    ? {
                        backgroundColor: "#F5F8FF",
                       
                      }
                    : undefined
                }
                key={index + daysInMonth.length}
                onClick={() => handleSelectDay(day)}
              >
                <div className="text-xs">{format(day, "d")}</div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="flex justify-center pt-3 flex-wrap gap-[8px]">
        {legendData.map((value, index) => (
          <div className="flex gap-1 items-center" key={index}>
            {value.color}
            <p className="text-xs">{value.display}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LeaveAndHolidaysMonthEventsCalendar;
